'use strict';

/**
 * @ngdoc function
 * @name gfcmsApp.controller:CustomerOrdersCtrl
 * @description
 * # CustomerOrdersCtrl
 * Controller of the gfcmsApp
 */
angular.module('gfcmsApp')
  .controller('CustomerOrdersCtrl', function($scope, $http, $location, $routeParams, $timeout,
    $filter, CustomerService, FlashService, cfpLoadingBar, orderService, modalService) {


    var customerOrdersVm = this;
    var customerId = $routeParams.customerId;
    var homeId = $routeParams.homeId;
    var orderId = $routeParams.orderId;

    customerOrdersVm.customerId = customerId;
    customerOrdersVm.homeId = homeId;
    customerOrdersVm.customerOrderList = [];
    customerOrdersVm.homes = [];
    customerOrdersVm.getOrders = getOrders;
    customerOrdersVm.deleteOrder = deleteOrder;
    customerOrdersVm.isSelectedOrder = isSelectedOrder;
    customerOrdersVm.inprogress = false;

    activate();

    function activate() {
      customerOrdersVm.getOrders(customerId);
    }

    function isSelectedOrder(id) {
      return !orderId || orderId === id;
    }

    function getOrders(id) {
      cfpLoadingBar.start();
      customerOrdersVm.inprogress = true;
      CustomerService.getOrders(id)
        .then(getCustomerOrdersSuccess)
        .catch(responseError)
        .finally(requestComplete);
    }

    /**
     * @param {String} id
     * @return Promise<void>
     */
    function deleteOrder(id) {
      customerOrdersVm.inprogress = true;
      modalService.showModal({}, {
        closeButtonText: 'Cancel',
        actionButtonText: 'Yes',
        headerText: 'Delete Order',
        bodyText: `Are you sure you want to delete this order?`
      }).then(_ => orderService.delete(id)
          .then(function () {
            FlashService.Success('Order successfully deleted');
            activate();
          })
          .catch(responseError)
          .finally(requestComplete));
    }

    function getCustomerOrdersSuccess(response) {
      customerOrdersVm.customerOrderList = response;
      customerOrdersVm.hasOrders = customerOrdersVm.customerOrderList.length > 0;

      customerOrdersVm.homes = response.map(function(item) {
        var home = {};
        home.address = $filter('address')(item.home);
        home.homeId = item.home.id;
        return home;
      });

      if (!!customerOrdersVm.homeId) {
        customerOrdersVm.selectedHome =customerOrdersVm.homeId;
      }

      if (!!orderId) {
        $timeout(function () {
          var selector = '#' + orderId;
          var $elm = angular.element(selector);
          console.log($elm, $elm.offset(), $elm.offset().top);
          angular.element('html, body').animate({scrollTop: $elm.offset().top - 70}, 400);
        }, 0);
      }
    }

    function responseError(error) {
      FlashService.Error('Network Error. Try reloading the page', false);
    }

    function requestComplete() {
      customerOrdersVm.inprogress = false;
      cfpLoadingBar.complete();
    }

    return customerOrdersVm;

  });
